import React from 'react';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

import { formatDateLongMonthWithMeridiemNoSeconds } from '~/services/TimeService';

import type { FieldHistoryEntry } from './types';

const EMPTY_VALUE = '—';

interface Props {
  emptyMessage?: string;
  entries: Array<FieldHistoryEntry>;
}

export default function FieldHistoryTable({ emptyMessage = 'No field changes recorded yet.', entries }: Props) {
  if (entries.length === 0) {
    return (
      <Typography color="text.secondary" sx={{ p: 3 }} variant="body2">
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <TableContainer>
      <Table size="small" aria-label="Field history">
        <TableHead>
          <TableRow>
            <TableCell>Date and time</TableCell>
            <TableCell>Field</TableCell>
            <TableCell>User</TableCell>
            <TableCell>Previous value</TableCell>
            <TableCell>New value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entries.map((entry) => (
            <TableRow key={entry.id}>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>
                {formatDateLongMonthWithMeridiemNoSeconds(entry.changedAt)}
              </TableCell>
              <TableCell>{entry.field}</TableCell>
              <TableCell>{entry.user}</TableCell>
              <TableCell>{entry.previousValue || EMPTY_VALUE}</TableCell>
              <TableCell>{entry.newValue || EMPTY_VALUE}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
